import { ADD_PREFIX, SETTINGS } from './common';

export const CAR_BRANDS = 'car-brands';
export const CAR_BRAND = ':carBrandId';

export const CAR_MODELS = 'models';
export const CAR_MODEL = ':carModelId';

export const CAR_BRAND_ROUTES = {
  CAR_BRANDS: `/${SETTINGS}/${CAR_BRANDS}`,
  CAR_BRAND: `/${SETTINGS}/${CAR_BRANDS}/${CAR_BRAND}`,
  CAR_MODEL: `/${SETTINGS}/${CAR_BRANDS}/${CAR_BRAND}/${CAR_MODEL}`,
  ADD_CAR_BRAND: `/${SETTINGS}/${CAR_BRANDS}/${ADD_PREFIX}`,
  ADD_CAR_MODEL: `/${SETTINGS}/${CAR_BRANDS}/${ADD_PREFIX}-model`,
};
